import { ShieldCheck, Search, Mail } from "lucide-react";
import { Reveal } from "./Reveal";

const CARDS = [
    {
        icon: ShieldCheck,
        num: "01",
        title: "Look Professional",
        text: "A professional website gives potential customers confidence and creates a strong first impression.",
        testId: "why-card-look-professional",
    },
    {
        icon: Search,
        num: "02",
        title: "Be Found Online",
        text: "Customers often search online before deciding which business to contact.",
        testId: "why-card-be-found-online",
    },
    {
        icon: Mail,
        num: "03",
        title: "Make It Easy To Contact You",
        text: "A clear website helps customers understand what you do and gives them an easy way to get in touch.",
        testId: "why-card-make-it-easy",
    },
];

export const WhyWebsite = () => (
    <section
        id="why-a-website"
        data-testid="why-a-website-section"
        className="bg-zinc-100 py-24 lg:py-32"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <Reveal>
                <p className="font-mono-label text-xs font-medium tracking-[0.25em] uppercase text-blue-600 mb-5">
                    Why A Website?
                </p>
                <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-zinc-950 max-w-2xl leading-tight">
                    Your next customer is already looking online.
                </h2>
            </Reveal>

            <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
                {CARDS.map((card, i) => (
                    <Reveal key={card.title} delay={i * 0.12}>
                        <article
                            data-testid={card.testId}
                            className="group h-full bg-white rounded-2xl border border-zinc-200 p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-blue-600/50 hover:shadow-[0_20px_40px_-24px_rgba(9,9,11,0.25)]"
                        >
                            <div className="flex items-start justify-between">
                                <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center transition-colors duration-300 group-hover:bg-blue-600">
                                    <card.icon
                                        size={22}
                                        className="text-blue-600 transition-colors duration-300 group-hover:text-white"
                                    />
                                </div>
                                <span className="font-mono-label text-xs text-zinc-400 tracking-widest">
                                    {card.num}
                                </span>
                            </div>
                            <h3 className="mt-7 text-xl font-semibold text-zinc-900 tracking-tight">
                                {card.title}
                            </h3>
                            <p className="mt-3 text-base text-zinc-600 leading-relaxed">
                                {card.text}
                            </p>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
